import { graphql } from "gatsby"
import React from "react"
import Link from "../components/link"

interface ISliceProps {
  data: Queries.FeaturedBlogsSliceQuery
}

const FeaturedBlogs = ({ data }: ISliceProps): JSX.Element => {
  // console.log(`FeaturedBlogs`)
  // const posts = [
  //   data?.featured1?.nodes[0],
  //   data?.featured2?.nodes[0],
  //   data?.featured3?.nodes[0],
  // ]
  const posts = []
  if (data?.featured1?.nodes[0]) posts.push(data?.featured1?.nodes[0])
  if (data?.featured2?.nodes[0]) posts.push(data?.featured2?.nodes[0])
  if (data?.featured3?.nodes[0]) posts.push(data?.featured3?.nodes[0])
  return (
    <>
      <h2 className="text-white">Featured news</h2>
      <ul className="p-0 list-none">
        {posts?.map(node => (
          <li className="before:content-none mb-4 group" key={node.id}>
            <div className="block lg:flex gap-6 items-center">
              <div className="w-full lg:w-1/4">
                <Link
                  to={node.uri}
                  data-categories={node.categories.nodes
                    .map(n => n.slug)
                    .join(`,`)}
                  data-tags={node.tags.nodes.map(n => n.slug).join(`,`)}
                >
                  <div className="aspect-[4/3] relative overflow-hidden w-full shrink-0">
                    <img
                      className="aspect-[4/3] object-cover w-full object-top group-hover:scale-110 transition-transform ease-in-out duration-300"
                      src={node.featuredImageSrc}
                      alt={node.featuredImageAlt}
                    />
                  </div>
                </Link>
              </div>
              <div className="w-full lg:w-3/4">
                <Link
                  to={node.uri}
                  data-categories={node.categories.nodes
                    .map(n => n.slug)
                    .join(`,`)}
                  data-tags={node.tags.nodes.map(n => n.slug).join(`,`)}
                  className="text-white no-underline"
                >
                  <h3 className="text-lg text-white font-bold mb-4 underline">
                    {node.title}
                  </h3>
                  <span dangerouslySetInnerHTML={{ __html: node.excerpt }} />
                </Link>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}

export default FeaturedBlogs

export const query = graphql`
  fragment FeaturedBlogPost on WpPost {
    id
    uri
    title
    excerpt
    date
    featuredImageSrc
    featuredImageAlt
    categories {
      nodes {
        slug
      }
    }
    tags {
      nodes {
        slug
      }
    }
  }
  query FeaturedBlogsSlice {
    featured1: allWpPost(
      limit: 1
      filter: {
        tags: { nodes: { elemMatch: { slug: { in: ["featured-1"] } } } }
      }
    ) {
      nodes {
        ...FeaturedBlogPost
      }
    }
    featured2: allWpPost(
      limit: 1
      filter: {
        tags: { nodes: { elemMatch: { slug: { in: ["featured-2"] } } } }
      }
    ) {
      nodes {
        ...FeaturedBlogPost
      }
    }
    featured3: allWpPost(
      limit: 1
      filter: {
        tags: { nodes: { elemMatch: { slug: { in: ["featured-3"] } } } }
      }
    ) {
      nodes {
        ...FeaturedBlogPost
      }
    }
  }
`
